<template>
  <div class="page-container">
    <div v-if="ssLen === 2" class="tab-bar">
      <div class="tab-item" :class="{ active: selectedType == 'gx' }" @click="selectSs('gx')">个险</div>
      <div class="tab-item" :class="{ active: selectedType == 'tx' }" @click="selectSs('tx')">团险</div>
    </div>
    <div class="content">
      <img class="user-head" src="@/static/images/user-head.png" />
      <div class="content-01">
        <span class="name">{{ data.salesSupportName | ssnFilter }}</span>
        <img :src="data.salesSupportQrcode" class="qr-code" />
        <span class="describe">请先保存上方二维码，保存后通过微信添加销售支持，即可享受专业解答，让您的问题迎刃而解。</span>
      </div>
      <div class="btn-box">
        <div class="save-qr-code" @click="downloadQrCode">保存二维码</div>
        <div class="add" @click="goAndAdd">去添加</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      selectedType: 'gx',
      gxSsData: {},
      txSsData: {},
      ssLen: 0
    };
  },
  filters: {
    ssnFilter(ssn) {
      if (!ssn) {
        return '';
      }
      return ssn + '老师';
    }
  },

  created() {
    this.getInfoData();
  },

  methods: {
    async getInfoData() {
      let gxSsRes = null;
      try {
        gxSsRes = await this.$http({
          url: '/app/okbao/getSalesSupport',
          type: 'GET',
          data: {
            type: 1
          }
        });
        this.gxSsData = gxSsRes.data; // 个险
        if (gxSsRes.data.hasSalesSupport != '0') {
          this.ssLen += 1;
        }
      } catch (err) {
        console.err(err);
      }
      let txSsRes = null;
      try {
        txSsRes = await this.$http({
          url: '/app/okbao/getSalesSupport',
          type: 'GET',
          data: {
            type: 2
          }
        });
        this.txSsData = txSsRes.data; // 团险
        if (txSsRes.data.hasSalesSupport != '0') {
          this.ssLen += 1;
        }
      } catch (err) {
        console.err(err);
      }
      if (this.ssLen === 2 || this.gxSsData.salesSupportName) {
        this.selectSs('gx'); // 默认选择个险
      } else {
        this.selectSs('tx');
      }
    },

    selectSs(t) {
      this.selectedType = t;
      if (t == 'gx') {
        this.data = this.gxSsData;
      } else if (t == 'tx') {
        this.data = this.txSsData;
      }
    },

    // 下载二维码
    downloadQrCode() {
      if (this.$config.isApp) {
        this.$app.download(
          {
            type: 'image',
            url: this.data.salesSupportQrcode
          },
          res => {
            this.$notice.msg('保存成功');
          },
          rej => {
            this.$notice.msg('保存失败');
          }
        );
      } else {
        this.downloadImg();
      }
    },

    downloadImg(Url = this.data.salesSupportQrcode) {
      const fileName = '二维码.jpg';
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = Url;
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(Url, fileName);
      }
    },

    // 去添加
    goAndAdd() {
      if (this.$config.isApp) {
        this.$app.openWechat();
      } else {
        this.$notice.msg('请在app中去添加');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  background: linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #ffe7d5 100%);

  .tab-bar {
    display: flex;
    height: 90px;
    width: 100%;
    font-family: PingFang SC, PingFang SC;
    border-bottom: 1px solid #e3e3e3;
  }

  .tab-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;
    width: 50%;
    font-weight: 400;
    font-size: 32px;
    color: #666666;

    &.active {
      font-weight: 500;
      font-size: 36px;
      color: #333333;

      &::after {
        position: absolute;
        bottom: 0;
        left: 50%;
        content: '';
        display: block;
        width: 34px;
        height: 4px;
        margin-left: -17px;
        background: #ff8b00;
        border-radius: 3px;
      }
    }
  }

  .content {
    width: 100%;
    padding: 132px 55px 0px 55px;
    display: flex;
    flex-direction: column;
    position: relative;
    .user-head {
      position: absolute;
      top: 45px;
      width: 160px;
      height: 160px;
      left: 50%;
      margin-left: -80px;
      border: 3px solid #fff;
      border-radius: 50%;
    }
    .content-01 {
      width: 640px;
      height: 640px;
      background: #fff;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 28px;
      .name {
        font-size: 36px;
        font-weight: bold;
        color: #333333;
        margin-top: 105px;
      }
      .qr-code {
        margin-top: 30px;
        width: 300px;
        height: 300px;
      }
      .describe {
        margin-top: 30px;
        font-size: 26px;
        color: #817a71;
      }
    }
    .btn-box {
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      .save-qr-code {
        width: 305px;
        height: 90px;
        border-radius: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        border: 1px solid #fc680a;
        color: #fc680a;
      }
      .add {
        width: 305px;
        height: 90px;
        border-radius: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        background: linear-gradient(264deg, #ff8b00 0%, #fc650b 100%);
        color: #ffffff;
      }
    }
  }
}
</style>
